import script from "./ConfigureTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureTerminal.vue?vue&type=script&setup=true&lang=js"

import "./ConfigureTerminal.vue?vue&type=style&index=0&id=4c365d68&lang=scss"

const __exports__ = script;

export default __exports__